import { QueryKey } from 'constants/reactQuery';
import { contentsQueryKey } from 'queries/contents/queryKey';

export const contentNotiQueryKey = {
  noti: (id: number) => [...contentsQueryKey.content(id), QueryKey.NotiNewEpisode] as const,
  notiContentsCount: (contentIds: number[]) =>
    [...contentsQueryKey.contents, contentIds.join('|'), QueryKey.NotiNewEpisode, 'count'] as const,
  notiContents: (contentIds: number[]) =>
    [...contentsQueryKey.contents, contentIds.join('|'), QueryKey.NotiNewEpisode] as const,
};
